<template>
  <app-layout title="Dashboard">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        ダッシュボード
      </h2>
    </template>

    <div class="py-12">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
          <div class="flex m-2">
            <div class="p-5 mr-4">
              ユーザ追加
            </div>
            <button
              class="mr-4 my-auto px-8 py-2 rounded bg-green-500 text-white max-w-max shadow-sm hover:shadow-lg"
              @click.prevent="onClickedUserRegistrationButton">
              ユーザの追加
            </button>
            <button
              class="my-auto px-8 p-2 rounded bg-blue-600 text-white max-w-max shadow-sm hover:shadow-lg"
              @click.prevent="onClickedUserRegistrationTasksButton">
              登録タスク一覧
            </button>
            <button
              class="ml-4 my-auto px-8 py-2 rounded bg-purple-600 text-white max-w-max shadow-sm hover:shadow-lg"
              @click.prevent="onClickedSchoolResultsButton">
              学校集計状況確認
            </button>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import AppLayout from '@/Layouts/AppLayout'

const onClickedUserRegistrationButton = () => {
  Inertia.get(route('usersRegistration'))
}

const onClickedUserRegistrationTasksButton = () => {
  Inertia.get(route('usersRegistration.task'))
}

const onClickedSchoolResultsButton = () => {
  Inertia.get(route('admin.school-results.index'))
}
</script>
